import React, { useEffect, useRef } from "react";
import { calc, getInsetTop, openWebView, ios } from "../../js/chips-common";
import { NumericFormat } from "react-number-format";
import "../../assets/fonts/font.css";

export default function CurrentMoney({ currentPrizeInfo }) {
  useEffect(() => {}, []);

  return (
    <div
      className={"active-only-alpha"}
      style={{
        display: "flex",
        position: "absolute",
        marginTop: calc(296),
        height: calc(34),
        lineHeight: calc(34),
        zIndex: 1,
        right: calc(80),
        // text align to right
      }}
      onClick={() => {
        openWebView(`${window.location.origin}/vending-machine/history`);
      }}
    >
      <div
        style={{
          fontFamily: "Gmarket Sans",
          fontSize: calc(33),
          fontWeight: 700,
          textTransform: "lowercase",
          backgroundColor: "transparent",
          background:
            "linear-gradient(180deg, #FFFFFF 0%, #59FCFE 50%, #59ABFE 75%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          textShadow: "0px 5px 20px 0px rgba(0, 0, 0, 0.25)",
        }}
      >
        {currentPrizeInfo}
      </div>
    </div>
  );
}
